import { FunctionComponent } from 'react'

import HybridTeaserContext from '@contexts/hybridTeaser'
import { TeaserMiddleToiAPIProps } from '@widgets/TeaserMiddleToi'
import { TeaserStandardHorizontalAPIProps } from '@widgets/TeaserStandardHorizontal'
import { TeaserStandardVerticalAPIProps } from '@widgets/TeaserStandardVertical'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import JSONRenderer from '@components/JSONRenderer'

export type SpecialHybridProps = {
  render?: 'vertical' | 'horizontal'
  variant?: 'middle-toi'
}

type TeaserHorizontalProps =
  | TeaserStandardHorizontalAPIProps
  | TeaserMiddleToiAPIProps

export type TeaserStandardHybridAPIProps = TeaserStandardVerticalAPIProps &
  TeaserHorizontalProps &
  SpecialHybridProps

const TeaserStandardHybrid: FunctionComponent<TeaserStandardHybridAPIProps> = ({
  render,
  variant,
  ...apiProps
}) => {
  const teaserStandardVerticalProps = {
    ...apiProps,
    kind: ['teaser-standard-vertical'],
  }

  const teaserStandardHorizontalProps = {
    ...apiProps,
    kind: [
      variant === 'middle-toi'
        ? 'teaser-middle-toi'
        : 'teaser-standard-horizontal',
    ],
  }

  return (
    <HybridTeaserContext.Provider value={true}>
      <JSONRenderer>
        {render === 'vertical'
          ? teaserStandardVerticalProps
          : render === 'horizontal'
            ? teaserStandardHorizontalProps
            : [teaserStandardVerticalProps, teaserStandardHorizontalProps]}
      </JSONRenderer>
    </HybridTeaserContext.Provider>
  )
}

const widget = {
  kind: ['teaser-standard-hybrid'],
  component: TeaserStandardHybrid,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
